// extracted by mini-css-extract-plugin
export default {"AdminPageAuth":"AdminPageAuth_AdminPageAuth__Jze6U"};